import React, { useLayoutEffect, useRef, useState } from 'react';
import styles from './Item.css';
import c from 'classnames';
import { strippedContent } from '../../lib/helpers';
import { useCurrentBreakPoint } from '../commons';

export const shortner = (content, maxNumOfChars) => {
  const stripped = strippedContent(content);
  return stripped
    .substring(0, (stripped + ' ').lastIndexOf(' ', maxNumOfChars))
    .concat(stripped.length > maxNumOfChars ? '...' : '');
};

export const ItemDescription = ({ item }) => {
  const [title, setTitle] = useState(item.title);
  const [description, setDescription] = useState(item.description);
  const titleRef = useRef({ current: null });
  const descriptionRef = useRef({ current: null });
  const currentBreakPoint = useCurrentBreakPoint();

  useLayoutEffect(() => {
    const tRef = titleRef.current;
    const dRef = descriptionRef.current;
    if(!tRef || !dRef) {
      return;
    }
    if (tRef.scrollHeight === 20) {
      tRef.dataset.lines = 1;
      setDescription(strippedContent(description));
      if (dRef.scrollHeight === 40) {
        dRef.dataset.lines = 2;
        setDescription(strippedContent(description));
      } else if (dRef.scrollHeight > 40) {
        dRef.dataset.lines = 2;
        setDescription(shortner(description, 50));
      }
    } else if (tRef.scrollHeight === 40) {
      tRef.dataset.lines = 2;
      if (dRef.scrollHeight > 20) {
        dRef.dataset.lines = 1;
        setDescription(shortner(description, 27));
      }
    } else if (tRef.scrollHeight > 40) {
      tRef.dataset.lines = 2;
      setTitle(shortner(title, 40));
      if (dRef.scrollHeight > 20) {
        dRef.dataset.lines = 1;
        setDescription(shortner(description, 27));
      }
    }

  }, [currentBreakPoint]);

  return (
    <div className={styles.desc} data-id={`id${item.id}`}>
      <h3 className="title" ref={titleRef} dangerouslySetInnerHTML={{ __html: title}} ></h3>
      <div className={c(styles.description, 'description')} ref={descriptionRef}
        dangerouslySetInnerHTML={{ __html: description}}>
      </div>
    </div>
  );
};
